import Navigation from '../../components/feature/Navigation';
import Footer from '../../components/feature/Footer';
import HomeHero from './components/HomeHero';
import BrowseByType from './components/BrowseByType';
import FeaturedProperties from './components/FeaturedProperties';
import ExploreByCity from './components/ExploreByCity';
import ActionCards from './components/ActionCards';
import WhyUs from './components/WhyUs';
import TrustedBrokers from './components/TrustedBrokers';
import FeaturedProjects from './components/FeaturedProjects';
import HomeNextSteps from './components/HomeNextSteps';
import StickyMobileCta from './components/StickyMobileCta';
import { useSeo } from '../../hooks/useSeo';
import { useTranslation } from 'react-i18next';

// Safaqat 24 homepage: white page, teal structure (THEME.md). Every section is
// wired to real data / real routes; the shared Navigation + Footer are reused
// as-is. The trusted-brokers band is merged in from the /brokers/map page.
//
// 2026-10 (owner): the services strip under the hero, the category strip with
// the safaqat24.sa line, and the closing «جاهز للإضافة؟» panel are gone. Their
// components (BrandStrip, ListCta) stay in the tree for an easy rollback.
export default function Home() {
  const { i18n } = useTranslation();
  const isRTL = i18n.dir() === 'rtl';
  useSeo({
    title: isRTL ? 'صفقات 24 | عقارات للبيع والإيجار في السعودية' : 'Safaqat 24 | Properties for sale & rent in Saudi Arabia',
    description: isRTL
      ? 'ابحث عن شقق وفلل وأراضٍ للبيع والإيجار في الرياض وجدة وجميع مدن المملكة.'
      : 'Search apartments, villas, and land for sale and rent across Riyadh, Jeddah, and all Saudi cities.',
  });
  return (
    <div className="min-h-screen bg-white text-ink">
      {/* Solid, locked nav; the hero photo starts directly below it. */}
      <Navigation />

      <main id="main-content">
        <HomeHero />
        <BrowseByType />
        <FeaturedProperties />
        <ExploreByCity />
        <ActionCards />
        <WhyUs />
        <TrustedBrokers />
        <FeaturedProjects />

        {/* Closing "next steps" strip — the same context-aware promos
            (account, listing, newsletter) the PromoRail band showed, set as one
            quiet row instead of a third row of cards (2026-10-06). */}
        <div className="pt-14 sm:pt-16">
          <HomeNextSteps />
        </div>
      </main>

      <Footer />
      <StickyMobileCta />
    </div>
  );
}
